<template>
  <div style="background-color:white">
    <v-toolbar v-if="generate" flat>
      <v-btn color="info" @click="getDocument()">{{ generate }}</v-btn>
    </v-toolbar>

    <div :class="{ 'full-screen-editor': isFullScreen }">
      <div class="ma-2">
        <h1>{{ title }}</h1>

        <v-alert
          timeout="6000"
          dense
          dismissible
          v-if="successMessage != ''"
          type="success"
        >
          {{ successMessage }}
        </v-alert>
        <v-alert
          dismissible
          dense
          v-if="errorMessage != '' && errorMessage"
          type="error"
        >
          {{ errorMessage }}
        </v-alert>

        <v-toolbar class="ma-2" flat>
          <v-spacer></v-spacer>
          <v-text-field
            class="mt-4 mr-2"
            v-if="eMailSubject"
            label="Subject"
            v-model="eMailSubject"
          ></v-text-field>

          <v-text-field
            class="mt-4 mr-2"
            label="Email"
            v-model="emailAddress"
          ></v-text-field>
          <v-btn
            :loading="loading"
            v-if="emailAddress"
            class="ma-4"
            text
            :color="btnColor"
            @click="sendMail()"
            ><v-icon class="mr-2">mdi-send</v-icon>
            <div>Send</div>
          </v-btn>
          <!-- v-if="type == 'document'" -->
          <v-btn
            v-if="$root.isMobile || $root.isTablet"
            class="ma-4"
            :loading="loading"
            icon
            color="warning"
            @click="showDoc = true"
            ><v-icon>mdi-clipboard-outline</v-icon>
            <span class="ma-2" v-if="!$root.isMobile"> Get Signed</span>
          </v-btn>
          <v-btn
            class="ma-4"
            text
            :loading="loading"
            color="warning"
            @click="createPdf()"
            ><v-icon>mdi-printer</v-icon
            ><span class="ma-2" v-if="!$root.isMobile"> Print </span></v-btn
          >

          <v-tooltip
            v-if="!$root.isMobile && !$root.isTablet && !noFullScreen"
            top
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="toggleFullScreen"
                ><v-icon v-if="!isFullScreen">mdi-fullscreen</v-icon
                ><v-icon round color="error" v-else
                  >mdi-fullscreen-exit</v-icon
                ></v-btn
              >
            </template>
            <span>Toggle Full Screen</span>
          </v-tooltip>
        </v-toolbar>

        <div
          v-if="!showDoc"
          class="document-body"
          style="border: 1px solid; overflow: auto;"
        >
          <v-editable :key="templateKey" :model="letterBody" />
        </div>
      </div>

      <!-- </v-dialog> -->
      <div v-if="dataReady">
        <div v-if="error">
          <span> Your code contains an error </span>
          <pre v-text="error" />
        </div>
        <!-- modelReady:{{ modelReady }} model:{{ model }} -->
        <!-- <div v-if="modelReady">{{ parsedBodyTemplate }}</div> -->
        <!-- <div v-if="modelReady">{{ model.company }}</div> -->
        <!-- parsedBodyTemplate: {{ parsedBodyTemplate }} -->
        <div hidden ref="body">
          <v-runtime-template
            v-if="modelReady && model"
            :template="parsedBodyTemplate"
          >
            <div slot="error" slot-scope="props">
              {{ props.error.message }}
            </div>
          </v-runtime-template>

          <component :is="compiled"></component>
        </div>
        <!-- test group by -->

        <!-- v-for="(t, j) in createGroupBy('inventory', 'room')"
        :key="j"  -->
        <!-- <h4>{{ t }}</h4> -->
        <!-- .filter((f) => {
              return f['room'] == t;
            })" -->

        <!-- end test -->

        <div hidden ref="intro_body">
          <v-runtime-template
            v-if="modelReady && model"
            :template="parsedIntroBodyTemplate"
          >
            <div slot="error" slot-scope="props">
              {{ props.error.message }}
            </div>
          </v-runtime-template>
        </div>
      </div>

      <v-dialog fullscreen class="customer-doc" v-model="showDoc">
        <v-toolbar class="footer-toolbar-">
          <v-btn @click="showDoc = false" text>Close</v-btn>
          <v-spacer />
          <v-btn color="success" @click="submitDocument()" text>Submit</v-btn>
        </v-toolbar>
        <div class="document-wrapper">
          <v-customer-document
            v="if=documentModel"
            :onDevice="true"
            :body="letterBody"
            :docName="documentModel ? documentModel.document_name : ''"
            objName="shipment"
            :recId="recId"
            ref="customerDocument"
            :close="close"
          ></v-customer-document>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import VRuntimeTemplate from "v-runtime-template";
import * as fun from "../plugins/common";
import _ from "lodash";
import axios from "axios";
import Vue from "vue";

Vue.directive("filter", {
  bind(el, binding, vnode) {
    // Get the filter function from the expression in the directive
    const filterFunction = binding.value;

    // Get the original v-for expression
    const vForExpression = el.getAttribute("v-for");

    // Modify the v-for expression to apply the filter
    const newVForExpression = `${vForExpression} | filterBy(${filterFunction})`;

    // Update the v-for expression with the modified one
    el.setAttribute("v-for", newVForExpression);
  },
});

export default {
  name: "Document",
  components: {
    VRuntimeTemplate,
    VEditable: () => import("../components/Editable.vue"),
    VCustomerDocument: () => import("../views/CustomerDocument.vue"),
  },
  props: {
    model: Object,
    documentModel: Object,
    email: String,
    bodyTemplate: String,
    introBodyTemplate: String,
    parentModel: Object,
    parModel: Object,
    formModel: Object,
    add_data_name: String,
    generate: String,
    qryFn: Function,
    qry: String,
    feedback: Function,

    // eMailSubject: String,
    // letterId: String,

    // rendered: Function,
  },
  data() {
    return {
      portalId: "",
      companyId: "",
      modelReady: false,
      rendered: false,
      letterBody: "",
      introBody: "",
      letterId: "",
      eMailSubject: "",
      title: "",
      templateKey: 0,
      successMessage: "",
      errorMessage: "",
      defaultLinkText: "Please click here to view and sign the document",
      defaultCustomerPortalText: "Please use the link to sign into your portal",
      error: false,
      parsedBodyTemplate: "",
      parsedIntroBodyTemplate: "",
      linkValue: "",
      documentId: "",
      compiled: null,
      dataReady: false,
      emailAddress: "",
      btnColor: "info",
      loading: false,
      parentTable: null,
      myDialog: false,
      showDoc: false,
      recId: "",
      dataGroupBy: {},
      isFullScreen: false,
      editedBody: "",
    };
  },
  errorCaptured(error, vm, info) {
    this.error = error.toString();
    //this.bodyTemplate
    console.error(error);
    return false; // prevent error from propagating further
  },
  mounted() {
    this.$root.$on("editableChanged", (v) => {
      this.editedBody = v;
    });

    this.portalId = this.$root.portal_id;
    var par = fun.getParentByProperty(this, "generate");
    this.parentTable = fun.getParentByProperty(par, "table");
    if (this.model && this.model.company) {
      this.companyId = this.model.company.company_id || this.model.company;
    }
    if (this.model) {
      this.recId = this.model._id;
    }

    if (this.documentModel) {
      // this.extractContentDiv();
      // this.applyInlineStyles();
      this.initDocument();
      this.myDialog = true;
      this.type = this.documentModel.type;
    } else {
      // this.init();
    }
    this.$root.$on("valueChange", (d) => {
      console.log(d);
      if (d.obj.model && d.obj.model.document_name) {
        console.log("document");
      }
    });
    // console.log(this.letterBody);
  },

  computed: {},

  methods: {
    close() {
      this.showDoc = false;
    },
    print() {
      // Open a new window or tab
      let printWindow = window.open("", "_blank");

      // Write the HTML content into the new window
      printWindow.document.write(this.letterBody);

      // Wait for the content to fully load
      printWindow.document.close(); // For some browsers, document.close() is necessary

      // Attach an onload event to the window to trigger the print dialog
      printWindow.onload = function() {
        printWindow.focus(); // Necessary for some browsers to focus on the new window
        printWindow.print(); // Trigger the print dialog
        printWindow.close(); // Close the window after printing
      };
    },
    createPdf() {
      this.loading = true;
      var data = {
        portal: this.portal,
        portal_id: "portal_" + this.$root.portal_id,
        object_name: "shipment",
        record_id: this.$route.params.id,
        filename: this.documentModel + "_" + this._id,
        html: this.editedBody || this.letterBody,

        // images: charts,
        // excel: isExcel,
        // data: this.data,
        // group_by: this.groupBy,
        // headers: this.headers,
      };
      this.$root.createPdf(data, (r) => {
        this.loading = false;
      });
    },
    // showDoc() {
    //   // var url = this.getLetterLink();
    //   // this.letterBody = "";
    //   // var wnd = window.open("about:blank");
    //   // wnd.document.write(this.letterBody);

    //   // axios.get(url).then((response) => {

    //   //   // this.letterBody = response.data;
    //   // });
    // },
    sorted(fld, groupByField) {
      fun.sortObjects(this.model[fld], groupByField);
      return this.model[fld];
    },
    newValueInGroupBy(fld, groupByField, i) {
      var isNew = this.dataGroupBy[fld] == this.model[fld][i][groupByField];
      this.dataGroupBy[fld] = this.model[fld][i][groupByField];
      return isNew;
    },
    createGroupBy(fld, groupByField) {
      this.dataGroupBy[fld] = [];
      var curValue = "";
      fun.sortObjects(this.model[fld], groupByField);
      this.model[fld].forEach((f) => {
        if (f[groupByField] != curValue) {
          curValue = f[groupByField];
          this.dataGroupBy[fld].push(f[groupByField]);
        }
      });
      return this.dataGroupBy[fld];
    },
    submitDocument() {
      this.$refs.customerDocument.submit();
      if (this.$refs.customerDocument.errorMessage) {
        alert(this.$refs.customerDocument.errorMessage);
      } else {
        this.myDialog = false;
      }
    },

    applyInlineStyles() {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.documentModel.body, "text/html");

      // Extract style blocks and parse CSS
      const styles = doc.querySelectorAll("style");
      let cssRules = [];
      styles.forEach((style) => {
        const cssText = style.innerText;
        const rules = cssText.split("}").map((rule) => {
          const [selectors, styles] = rule.split("{");
          return { selectors, styles };
        });
        cssRules = [...cssRules, ...rules];
      });

      // Apply inline styles to matching elements
      cssRules.forEach((rule) => {
        try {
          const elements = doc.querySelectorAll(rule.selectors.trim());
          elements.forEach((element) => {
            const styleAttribute = element.getAttribute("style") || "";
            element.setAttribute("style", `${styleAttribute} ${rule.styles}`);
          });
        } catch (error) {
          //
        }
      });

      // Serialize the document back to HTML
      this.bodyTemplate = new XMLSerializer().serializeToString(doc.body);
      this.bodyTemplate = this.bodyTemplate.replaceAll("&#10;", "");
    },
    extractContentDiv() {
      // Use the DOMParser API to parse the HTML string
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.documentModel.body, "text/html");

      // Find the div with the class 'content'
      const contentDiv = doc.querySelector(".content");

      // Check if the div was found
      if (contentDiv) {
        // Serialize the content div and its children with inline styles
        this.documentModel.body = this.serializeWithInlineStyles(contentDiv);
      } else {
        // If the .content div wasn't found, you can handle the error as needed
        console.error("The .content div was not found in the HTML string.");
      }
    },
    serializeWithInlineStyles(element) {
      // Clone the element to avoid modifying the original
      const clone = element.cloneNode(true);

      // Go through each element and set its computed style as inline style
      const elements = clone.getElementsByTagName("*");
      for (const el of elements) {
        const computedStyle = window.getComputedStyle(el);
        let styleString = "";
        for (const styleName of computedStyle) {
          styleString += `${styleName}:${computedStyle.getPropertyValue(
            styleName
          )};`;
        }
        el.setAttribute("style", styleString);
      }

      // Return the outer HTML of the cloned element
      return clone.outerHTML;
    },

    getDocument() {
      var that = this;
      this.myDialog = true;
      var document = this.formModel.document_name;
      if (document && document._id) {
        this.documentId = document._id;

        var url = this.serverURL + "/get_records";
        var data = {
          object_name: "document",

          qry: { _id: this.documentId },
        };

        axios
          .post(url, data, {
            withCredentials: true,
          })
          .then((response) => {
            // console.log(response);
            var docModel = response.data[0][0];
            this.documentModel = docModel;
            this.type = this.documentModel.type;
            this.bodyTemplate = docModel.body;
            // this.applyInlineStyles();
            this.companyId = docModel.company;
            // this.model = this.formModel;
            data = {
              object_name: docModel.category,

              qry: { _id: this.parentModel._id },
            };

            if (that.qry) {
              // that.qry = JSON.parse(that.qry);
              var f = that.formModel;
              try {
                var qry = fun.evalJson(that.qry, f);
                data.qry = {
                  ...data.qry,
                  ...qry,
                };
              } catch (error) {
                console.log(error);
              }
            }
            axios
              .post(url, data, {
                withCredentials: true,
              })
              .then((response) => {
                this.model = response.data[0][0];
                // console.log(that.formModel);
                if (this.model) {
                  this.model[that.add_data_name] = this.formModel;
                }

                this.initDocument();
              });
          });
      }
    },
    parseTemplate() {
      var url = this.serverURL + "/parse_template";
      var data = {
        body: fun.removeHtmlComments(this.bodyTemplate),
        document_data: this.model,
      };

      axios
        .post(url, data, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response.data);
          this.letterBody = response.data;
        });
    },
    getStyle() {
      let parser = new DOMParser();
      let doc = parser.parseFromString(this.bodyTemplate, "text/html");

      let styleElements = doc.querySelectorAll("style");
      let allStyles = "";

      styleElements.forEach((elem) => {
        allStyles += elem.textContent; // Concatenate the contents of each <style> tag
      });
      return "<style>" + allStyles + "</style>";
    },
    initDocument() {
      var that = this;
      // this.parseTemplate();
      this.bodyTemplate = fun.convertRelativeToAbsolute(
        this.bodyTemplate.replace(
          "model.company.phones.phone_number",
          "model.company.phones.office.phone_number"
        )
      );
      this.dataReady = true;

      // this.applyInlineStyles();
      this.parsedBodyTemplate = this.parsedTemplate(
        fun.removeHtmlComments(this.bodyTemplate)
      );
      if (this.introBodyTemplate) {
        this.parsedIntroBodyTemplate = this.parsedTemplate(
          fun.removeHtmlComments(this.introBodyTemplate)
        );
      }

      // const content = this.parsedBodyTemplate;
      // const newContent = content
      //   .replace(/<p[^>]*>/gi, "<br></br>")
      //   .replace(/<\/p>/gi, "");
      // const replacedContent = newContent.replace(/\n/g, "");

      // this.parsedBodyTemplate = "<div>" + this.parsedBodyTemplate + "</div>";
      // // this.parsedBodyTemplate = "<p><h1>test h1 </h1></p>";
      // // "<p><h2>Dear Agent!&nbsp;{{model.company}}</h2><br></br>Here is your invoice:</p>";
      // // this.compiled = Vue.compile(this.parsedBodyTemplate);
      // this.parsedIntroBodyTemplate = this.parsedTemplate(
      //   this.introBodyTemplate
      // );
      // this.compiled = Vue.compile(this.parsedBodyTemplate);

      this.modelReady = true;
      setTimeout(() => {
        if (!that.$refs.body) {
          return;
        }
        var b = that.$refs.body.innerHTML;

        b = b.replaceAll("sales_person_sign", this.sales_person_sign());
        if (b.indexOf("credit_card_link") != -1) {
          that.credit_card_link(b);
        }
        b = b.replaceAll("company_logo", this.companyLogo());
        b = b.replaceAll("{{}}", this.sales_person_sign());

        var b_intro = this.$refs.intro_body.innerHTML;

        that.letterBody = this.getStyle() + " " + fun.extractJsonFromString(b);

        // console.log(this.letterBody);
        that.introBody = fun.extractJsonFromString(b_intro);

        that.templateKey = !that.templateKey;
      }, 500);

      this.letterId = this.documentModel._id;
      try {
        var subject = fun.interpolate(this.documentModel.email_subject, {
          model: this.model,
        });
        this.eMailSubject = subject;
      } catch (error) {
        //
      }

      this.emailAddress = this.email;
      if (!this.emailAddress) {
        if (this.parentModel && this.parentModel.email) {
          this.emailAddress = this.parentModel.email;
        }
      }
    },
    filterBy(items, filterFunction) {
      return items.filter(filterFunction);
    },
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen;
    },
    getBody(b, body) {
      // var b = this.$refs[body].innerHTML;

      b = b.replaceAll("sales_person_sign", this.sales_person_sign());
      // b = b.replaceAll("credit_card_link", this.credit_card_link());
      // var b_intro = this.$refs.intro_body.innerHTML;
      if (body == "intro_body") {
        this.introBody = fun.extractJsonFromString(b);
      } else {
        this.letterBody = fun.extractJsonFromString(b);
      }

      this.createCustomerPortalLink();
    },
    extractField(field, data = this.model) {
      // Check if the field exists in the data object
      try {
        const value = field.split(".").reduce((obj, key) => obj?.[key], data);

        // If the field exists, return its value
        if (value !== undefined) {
          return value;
        }
      } catch (error) {
        return "";
      }
      return "";
      // If the field does not exist, return an empty string
    },
    init() {
      var document = this.formModel.document_name;
      if (document && document._id) {
        this.documentId = document._id;
        this.getDocument();
      }
    },
    parsedTemplate(template) {
      if (!template) {
        return "";
      }
      var that = this;
      // Parse the template and replace curly braces with their values, removing the "model." prefix if present
      const parsed = template.replace(/{{\s*([^{}]+?)\s*}}/g, (_, field) => {
        // Remove the "model." prefix from the field
        const cleanedField = field.trim().replace(/^model\./, "");

        // Get the value of the field from the data object
        const value = cleanedField
          .split(".")
          .reduce((obj, key) => obj?.[key], this.model);

        // If the value is undefined, return an empty string
        if (value === undefined && field.startsWith("model.")) {
          return "";
        }

        // Otherwise, return the value
        if (field.includes("card_number")) {
          return "{{ formatCC(" + field + ")}}";
        }
        return "{{" + field + "}}";
      });

      // Return the parsed template
      return parsed;
    },
    showError(errorMessage) {
      this.error = errorMessage;
    },
    formatCC(n) {
      try {
        return "************" + n.slice(-4);
      } catch (error) {
        return "";
      }
    },
    formatNumber(n) {
      return fun.formatNumber(n);
    },
    now(d) {
      var date = fun.formatDate(d, false, true, true);
      return date;
    },
    addMinuteToCurrentTime(m) {
      var date = new Date();
      date.addHours(m / 60);
      return fun.formatDate(date, false, true, true);
    },
    currentDate(d) {
      return fun.formatDate(d);
    },
    get_ach(k) {
      var ach = this.model.payment.filter((p) => {
        return p.ach;
      });
      if (ach.length) {
        var i = ach.length - 1;
        if (ach[i].ach.check_info) {
          var check_info = ach[i].ach.check_info;
          var checkInfo = "";
          // Object.keys(check_info).forEach((k) => {
          checkInfo += k + ": " + check_info[k];
          // });
          return checkInfo;
        }
      }
    },
    companyLogo() {
      if (this.model.shipment_detail) {
        var logoUrl = this.model.shipment_detail.company.logo_url;

        var logo = "<img style='max-width:250px'  src='" + logoUrl + "' />";
        return logo;
      }
    },
    credit_card_link(b) {
      var amount = prompt("Please enter payment amount");
      if (!amount) {
        amount = 0;
      }
      var encripted = {
        secret_data: {
          company_id:
            this.model.shipment_detail.company._id ||
            this.model.shipment_detail.company,
          portal_id: this.$root.portal_id,
          amount: amount,
          shipment_id: this.model.shipment_id,
        },
      };
      axios
        .post(this.serverURL + "/encrypt", encripted, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response);
          this.linkValue = "https://charge.moverai.com/#/c/" + response.data;
        });
    },

    sales_person_sign() {
      if (this.model && this.model.shipment_detail) {
        var data = {
          portal: "portal_" + this.$root.portal_id,
          object_name: "employee",
          record_id: this.model.shipment_detail.sales_person,
        };
        var path = "/user_images";
        var url;
        if (window.location.host.indexOf("localhost") != -1) {
          // path = "/public/user_images";
          url = "http://localhost:8080";
        } else {
          // path = "/user_images";
          url = "https://account.moverai.com";
        }
        path =
          url +
          path +
          "/" +
          data.portal +
          "/" +
          data.object_name +
          "/" +
          data.record_id +
          "/rep_signature.png";

        return "<img src='" + path + "' />";
      }
    },
    signature_pad(d) {
      return d;
    },
    getWeekDay(d) {
      return fun.getWeekDate(d);
    },
    today(modifier) {
      return fun.modifyDate(modifier);
    },
    capitalize(a) {
      return fun.capitalize(a);
    },
    chargeByName(chargeName) {
      if (this.model.service) {
        var charges = this.model.service.estimate_charges;
        if (charges) {
          var thisCharge = charges.filter((c) => {
            return c.charge == chargeName;
          });
          if (thisCharge.length) {
            return thisCharge[0].subtotal;
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      }
    },
    totalByType(chargeCategory) {
      if (this.model.service) {
        var charges = this.model.service.estimate_charges;
        var total = 0;
        if (charges) {
          var thisCharge = charges.filter((c) => {
            return c.charge_category == chargeCategory;
          });

          if (thisCharge.length) {
            thisCharge.forEach((c) => {
              total += parseFloat(c.subtotal);
            });
          }
        }
      }
      return total.toFixed(2);
    },
    sendMail() {
      var that = this;
      this.successMessage = "";
      this.errorMessage = "";
      var sentId = fun.guid();
      if (!this.editedBody) {
        this.editedBody = this.letterBody;
      }

      var letterBody = this.editedBody;
      if (this.linkValue) {
        letterBody = letterBody.replaceAll("credit_card_link", this.linkValue);
      }

      var introBody = "";
      if (
        this.documentModel &&
        (this.documentModel.send_as_link || this.documentModel.draggable)
      ) {
        introBody = this.createLink(sentId);
      }
      if (this.documentModel && this.documentModel.send_as_pdf) {
        introBody = this.introBody;
      }

      var mailData = {
        message: letterBody,
        intro_body: introBody,
        filename: this.documentModel.document_name,
        send_as_link: this.documentModel
          ? this.documentModel.send_as_link || this.documentModel.draggable
          : false,
        send_as_pdf: this.documentModel.send_as_pdf,

        subject: this.eMailSubject,
        email_to: [this.emailAddress],
        letter_id: this.letterId,
        sent_id: sentId,
        comp_id: this.documentModel.company,
        sender: this.$root.store.userData,
        receipient: this.model.customer
          ? this.model.customer.contact
          : this.model.contact,
      };
      if (this.$root.isHost) {
        mailData.company = {
          company_name: "eMover software",
          email: "info@emoversoftware.com",
        };
      }
      if (this.model) {
        mailData.shipment_id = this.model._id;
        // mailData.company_id = this.model.company.company_id;
      }
      this.loading = true;
      axios
        .post(this.serverURL + "/send_email_emover", mailData, {
          withCredentials: true,
        })
        .then((response) => {
          // console.log(response);
          this.loading = false;
          if (response.data.sent.includes("success")) {
            that.successMessage = response.data.sent;
            that.btnColor = "success";
          } else {
            that.errorMessage = "Error occured: " + response.data.sent;
            that.btnColor = "danger";
          }

          var sentDoc = {
            document_body: {
              letterBody: letterBody,
              introBody: introBody,
            },
            date_sent: fun.formatDate(new Date()),
          };
          this.$root.$emit("mailSent", {
            obj: this,
            response: response.data,
            sentDoc: sentDoc,
          });

          // if (this.feedback) {
          //   this.feedback(response.data);
          // }
        });
    },
    getLetterLink(sentId) {
      if (!sentId) {
        sentId = fun.guid();
      }
      var encrypted = encodeURIComponent(
        fun.encrypt(this.portalId + ":" + sentId, this.passPhrase)
      );
      var url = fun.siteLocation() + "/#/" + "customerdocument/" + encrypted;

      return url;
    },
    createLink(sentId) {
      var introBody = "";
      var url = this.getLetterLink(sentId);
      var letterLink =
        "<a href='" +
        url +
        "'>" +
        (this.documentModel.link_text || this.defaultLinkText) +
        "</a>";
      introBody = this.introBody + "<b><b><b>" + letterLink;
      return introBody;
    },
    createCustomerPortalLink() {
      var encrypted = encodeURIComponent(
        fun.encrypt(
          this.portalId + ":" + this.model.customer._id,
          this.passPhrase
        )
      );
      var letterLink =
        "<a href='" +
        fun.siteLocation() +
        "/#/" +
        "customerportal/" +
        encrypted +
        "'>" +
        (this.documentModel.customer_portal_link_text ||
          this.defaultCustomerPortalText) +
        "</a>";

      this.model.customer_portal_link = letterLink;

      this.letterBody = this.letterBody.replaceAll(
        "customer_portal_link",
        letterLink
      );
    },
    // bodyRendered(body) {
    //   return body;
    // },
  },
  watch: {
    formModel: {
      handler: function(oldValue, newValue) {
        // console.log(this.formModel, oldValue, newValue);
      },
      deep: true,
      // immediate: true,
    },
  },
};
</script>

<style lang="css">
.full-screen-editor {
  position: fixed;
  padding: 20px;
  top: 50px;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  z-index: 10000000000 !important;
  background-color: white;
}
.group-by-cell {
  border-color: white;
  border-right-color: inherit;
}
.active-group-by-cell {
  border-color: white;
  border-top-color: inherit;
}
.document-body {
  position: relative;
  height: 100vh !important;
  background-color: white;
}
.customer-doc {
  /* z-index: 1000000 !important; */
  height: 80% !important;
}
.document-wrapper {
  /* z-index: 1000000 !important; */
  position: relative;
  background-color: white;
}
.document-body .draggable-div {
  border: none !important;
  background-color: transparent !important;
  color: black !important;
}
.document-body .draggable-field-editable {
  border: none !important;
  background-color: transparent !important;
}
.document-body .resize-handle,
.document-body .remove-btn {
  display: none;
}
.document-body .style-btn {
  display: none;
}
.footer-toolbar {
  position: fixed;
  width: 100%;
  right: 0;
  bottom: 0;
}
@media only screen and (max-width: 450px) {
  .document-body {
    height: 52vh;
    /* width: 90vw !important; */
    overflow: auto !important;
  }
  /* .card-actions .v-toolbar__content {
    display: table !important;
  } */
  /* .card-actions .v-input {
    display: table-row !important;
    clear: both !important;
    width: 100% !important;
  } */
  /* .card-actions {
    position: fixed;
  } */
}
@media only screen and (min-width: 600px) {
  .document-body {
    height: 70vh !important;
    overflow: auto;
  }
  .panel-form .document-body {
    height: 60vh !important;
  }
  .full-screen-editor .document-body {
    height: 80vh !important;
  }
  .full-screen-editor .document-body {
    /* height: 80vh !important; */
  }
  .card-actions {
    position: fixed;
    bottom: 0;
    right: 30px;
    width: calc(100% - 320px);
    border-top: solid 1px;
    padding: 5px;
    /* margin: 5px; */
  }
}
</style>
